import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import { cn } from '@/lib/utils';

interface CopyableVinProps {
  vin: string;
  className?: string;
}

const buttonClasses = cn(
  'inline-flex items-center justify-center h-5 w-5 rounded',
  'hover:bg-muted/80 transition-colors'
);

export const CopyableVin: React.FC<CopyableVinProps> = ({ vin, className }) => {
  const { toast } = useToast();
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!vin) {
      toast({ title: 'Error', description: 'No VIN to copy', variant: 'destructive' });
      return;
    }
    try {
      await navigator.clipboard.writeText(vin);
      setCopied(true);
      toast({ title: 'Success', description: 'VIN copied to clipboard!', variant: 'success' });
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast({ title: 'Error', description: 'Failed to copy VIN', variant: 'destructive' });
    }
  };

  return (
    <span className={cn('inline-flex items-center gap-1', className)}>
      <span>VIN: {vin}</span>
      <button type='button' onClick={handleCopy} title='Copy VIN' className={buttonClasses}>
        {copied ? (
          <Check className='h-3 w-3 text-green-500' />
        ) : (
          <Copy className='h-3 w-3 text-muted-foreground hover:text-foreground' />
        )}
      </button>
    </span>
  );
};

export default CopyableVin;
